import { Accordion } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './faq.css'; // Adjust path if needed


const FAQ = () => {

    const faq = [
        {
            question: "What makes Gautam Solar panels different from other solar brands?",
            answer: "Gautam Solar manufactures high-efficiency solar panels using advanced AI-based defect detection and patented manufacturing processes. Our panels are designed for high durability, superior performance, and long-term reliability in Indian weather conditions."
        },
        {
            question: "Is Gautam Solar an ALMM-approved manufacturer?",
            answer: "Yes, Gautam Solar modules are listed under the MNRE ALMM (Approved List of Models and Manufacturers), ensuring compliance with Indian government standards."
        },
        {
            question: "What type of solar panels does Gautam Solar manufactures?",
            answer: "Gautam Solar manufactures advanced MonoPERC and high efficiency TOPCon solar PV modules suitable for rooftop, commercial, industrial, and large-scale solar power plants."
        },
        {
            question: "Where are Gautam Solar's manufacturing facilities located?",
            answer: "Gautam Solar has state-of-the-art module manufacturing facilities in Bhiwani (Haryana) and Haridwar (Uttarakhand), with an upcoming solar cell manufacturing unit in Malanpur, Gwalior (Madhya Pradesh)."
        },
        {
            question: "Are Gautam Solar panels suitable for rooftop installations?",
            answer: "Yes, Gautam Solar panels are ideal for residential, commercial, and industrial rooftop solar systems. Their high efficiency and compact design make them suitable for maximizing energy output in limited roof spaces."
        },
        {
            question: "Does Gautam Solar supply modules for large solar power plants?",
            answer: "Yes, Gautam Solar supplies high-performance solar modules for utility-scale solar power plants and large ground-mounted projects, supporting India’s growing renewable energy infrastructure."
        },
        {
            question: "How does Gautam Solar ensure quality and detect panel defects?",
            answer: "Gautam Solar ensures quality through 30+ in-line quality checks across fully automated manufacturing processes. Each module undergoes Electroluminescence (EL) testing to detect microcracks, IV (flash) testing to verify power output, insulation and safety tests, and mechanical load validation. Climate chamber testing further ensures durability under extreme conditions."
        },
        {
            question: "What is the expected degradation rate of Gautam Solar panels and how it impacts long term erformnce?",
            "answer": "Gautam Solar’s modules exhibit an industry-leading median degradation rate of approximately 1% for the first year and then 0.4% per year, ensuring over 90% of rated power output even after 20 years of operation. This low annual decline translates to 80–90% power retention at the end of a 25-year service life."
        },
        {
            question: "What should you consider when choosing a solar power plant?",
            answer: "When selecting a solar power plant, focus on key factors such as panel efficiency, product quality, manufacturer experience, warranty coverage, and installation standards. Choosing a trusted manufacturer and high-quality components helps ensure better performance, long-term savings, and minimal maintenance."
        },
        {
            question: "How are some solar panels more reliable than others?",
            answer: "The reliability of solar panels depends on factors such as manufacturing experience, quality of materials, certifications, and strict quality control processes. Panels produced by experienced manufacturers are typically designed to perform consistently and withstand environmental stress over their full lifespan."
        },

        { question: 'What is the expected degradation  rate of Gautam Solar panels and how does it impact long-term performance?', answer: 'Gautam Solar’s mono PERC and TOPCon modules exhibit an industry-leading median degradation rate of approximately 1% for the first year and then 0.4% per year, ensuring over 90 % of rated power output even after 20 years of operation. This low annual decline translates to 80–90 % power retention at the end of a 25-year service life, minimizing energy yield loss for large-scale and utility-scale solar EPC projects' }
    ]

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": 'FAQPage',
        "mainEntity": faq.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
            }
        }))
    };

    return (
        <div className="container py-5">
            <div className='border rounded' style={{ background: '#E5E7EB' }}>
                <Helmet>
                    <script type='application/ld+json'>
                        {JSON.stringify(faqSchema)}
                    </script>
                </Helmet>

                <h2 className="fw-semibold text-center textRes" style={{ color: '#a20000' }}> <span className='text-black'>FREQUENTLY</span> ASKED QUESTIONS</h2>
                <div className="container py-5 d-flex flex-column flex-md-row">

                    <div className="col-md-12"  >
                        <Accordion  >
                            {faq.map((item, index) => (
                                <Accordion.Item eventKey={index} key={index} className="custom-accordion-item">
                                    <Accordion.Header >{index + 1}. {item.question}</Accordion.Header>
                                    <Accordion.Body >
                                        {item.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
